/** @jsxImportSource @emotion/react */
import {css} from "@emotion/react";
import React from "react";

/**
 * 装飾付きの見出し.
 */
export const Heading = React.forwardRef<HTMLDivElement, { text: string, className?: string }>(({text, className}, ref) => {
    return <div className={className} ref={ref} css={css`
    font-size: 1.125rem/* 18px */;
    line-height: 1.75rem/* 28px */;
    box-sizing: border-box;
    position: relative;
    padding-left: 10px;

    &:before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      width: 3px;
      height: 100%;
      border-radius: 10px;
      background-color: #9C413C;
    }
  `}>
        {text}
    </div>
});
